import { render, staticRenderFns } from "./LangsAddUpdate.vue?vue&type=template&id=eb154fb4&scoped=true"
import script from "./LangsAddUpdate.vue?vue&type=script&lang=js"
export * from "./LangsAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb154fb4",
  null
  
)

export default component.exports